import { useEffect, type RefObject } from 'react';

/**
 * Opens a native `<dialog>` as a modal while the owning component is mounted and locks page scroll.
 * `showModal()` provides focus trapping, Escape handling and an inert background.
 */
export function useModalDialog(dialogRef: RefObject<HTMLDialogElement | null>) {
  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog) return;
    if (!dialog.open) dialog.showModal();
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    // No close() on cleanup: removing the element leaves the top layer without firing a late `close`
    // event that could be mistaken for a user dismissal.
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [dialogRef]);
}
